/*
 * © 2024 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */

export var getIconNumberClassName = function getIconNumberClassName(count, fill) {
  if (count < 0) return '';
  return "icon-number-".concat(count > 99 ? '99plus' : count).concat(fill ? '-fill' : '');
};